var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: "slide-in" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "store-overlay-panel",
            attrs: { id: "store-preview-overlay-panel" }
          },
          [_vm._t("default")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }